import { __assign, __extends, __rest } from "tslib";
import React from 'react';
import { BlueprintsManager, GALLERY_CONSTS, utils } from 'pro-gallery-lib';
import ProGallery from './proGallery/proGallery';
import basePropTypes from './proGallery/propTypes';
var BaseGallery = /** @class */ (function (_super) {
    __extends(BaseGallery, _super);
    function BaseGallery(props) {
        var _this = _super.call(this) || this;
        _this.blueprintsManager = new BlueprintsManager({ id: 'layoutingGallery' });
        _this.domId = props.domId || 'default-dom-id';
        _this.isUsingCustomInfoElements =
            props.customHoverRenderer ||
                props.customInfoRenderer ||
                props.customSlideshowInfoRenderer;
        _this.blueprintsManager.init({
            api: {
                isUsingCustomInfoElements: function () { return _this.isUsingCustomInfoElements; },
                fetchMoreItems: function (from) {
                    typeof props.eventsListener === 'function' &&
                        props.eventsListener(GALLERY_CONSTS.events.NEED_MORE_ITEMS, from);
                },
                onBlueprintReady: function (_a) {
                    var blueprint = _a.blueprint, blueprintChanged = _a.blueprintChanged, initialBlueprint = _a.initialBlueprint;
                    if (blueprintChanged) {
                        _this.setBlueprint(blueprint, initialBlueprint);
                    }
                    else {
                        if (utils.isVerbose()) {
                            console.count('>>> Blueprint not changed, not setting it');
                        }
                    }
                },
            },
        });
        _this.state = {
            blueprint: _this.blueprintsManager.createInitialBlueprint(props) || null,
        };
        _this.onNewProps(props, 'constructor');
        return _this;
    }
    BaseGallery.prototype.setBlueprint = function (blueprint, initialBlueprint) {
        if (initialBlueprint) {
            // the blueprint from the initial blueprint flow will be set in the constructor
        }
        else {
            this.setState({ blueprint: blueprint });
        }
    };
    BaseGallery.prototype.onNewProps = function (props, calledByConstructor) {
        var _this = this;
        var eventsListener = props.eventsListener, otherProps = __rest(props, ["eventsListener"]);
        var _eventsListener = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var eventName = args[0], value = args[1];
            if (eventName === GALLERY_CONSTS.events.NEED_MORE_ITEMS) {
                _this.blueprintsManager.getMoreItems(value);
            }
            else {
                typeof eventsListener === 'function' && eventsListener.apply(void 0, args);
            }
        };
        this.galleryProps = __assign(__assign({}, otherProps), { eventsListener: _eventsListener, domId: this.domId });
        if (calledByConstructor) {
            // the blueprint will be initiated with the state
        }
        else {
            this.blueprintsManager.createBlueprint(this.galleryProps).catch(function (e) {
                //TODOVER3 check totalItemsCount
                console.error('Could not create a blueprint from the new props', e);
            });
        }
    };
    BaseGallery.prototype.UNSAFE_componentWillReceiveProps = function (newProps) {
        this.onNewProps(newProps);
    };
    BaseGallery.prototype.render = function () {
        var blueprint = this.state.blueprint;
        if (blueprint && Object.keys(blueprint).length > 0) {
            return React.createElement(ProGallery, __assign({}, this.galleryProps, blueprint));
        }
        else {
            return null;
        }
    };
    BaseGallery.propTypes = basePropTypes;
    return BaseGallery;
}(React.Component));
export default BaseGallery;
//# sourceMappingURL=index.js.map